import { MapStyles } from './types.js';

export const MAP_STYLES: MapStyles = {
  SATELLITE: {
    url: 'mapbox://styles/buckrivard/clertmasg000t01mvw0cvb340',
    name: 'Satellite',
  },
  STREET: { url: 'mapbox://styles/buckrivard/clerial3b000m01mv5fntb5r1', name: 'Street' },
};

export const MAP_SOURCES = Object.freeze({
  SUBJECT: 'subject',
  PINS: 'pins',
});

export const POLY_DRAW_BTN_SELECTOR = 'mapbox-gl-draw_polygon';
export const TRASH_BTN_SELECTOR = 'mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_trash';
